import { render, staticRenderFns } from "./questionConsultation.vue?vue&type=template&id=6b9c5530&scoped=true"
import script from "./questionConsultation.vue?vue&type=script&lang=js"
export * from "./questionConsultation.vue?vue&type=script&lang=js"
import style0 from "./questionConsultation.vue?vue&type=style&index=0&id=6b9c5530&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c5530",
  null
  
)

export default component.exports